import type { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { useGroup } from "@/providers/GroupProvider";

/** Redirects non-English department students away from English-only pages. */
export default function EnglishOnlyRoute({ children }: PropsWithChildren) {
  const { group, isEnglish } = useGroup();

  // Group still loading — wait before deciding.
  if (!group) return null;
  if (!isEnglish) return <Navigate to="/home" replace />;
  return <>{children}</>;
}
